import React from "react";

function EmptyCart() {
  return (
    <svg width="111" height="104" viewBox="0 0 111 104" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M62.6035 78L80 50H37.7515L20 74.7692L62.6035 78Z"
        stroke="#9C9C9A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M80.2831 50L80.9999 52.1429L64 80.5L20.9999 77L19.9248 74.8571"
        stroke="#9C9C9A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M29.5 62L71.5 63.5" stroke="#9C9C9A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M70 50L53 77" stroke="#9C9C9A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M58 50L42 76" stroke="#9C9C9A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M47 50L30 75" stroke="#9C9C9A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M28.9619 16L29.0903 15.2611C28.7813 15.2074 28.4715 15.3517 28.3137 15.6228C28.1559 15.8939 28.1836 16.2346 28.3829 16.4767L28.9619 16ZM15.3852 39.2857L15.5136 38.5467C15.2045 38.493 14.8947 38.6373 14.737 38.9084C14.5792 39.1796 14.6068 39.5202 14.8062 39.7624L15.3852 39.2857ZM31.4828 25.128C31.4828 32.6503 25.3848 38.7484 17.8625 38.7484V40.2484C26.2132 40.2484 32.9828 33.4788 32.9828 25.128H31.4828ZM28.3829 16.4767C30.3201 18.8296 31.4828 21.842 31.4828 25.128H32.9828C32.9828 21.4815 31.6911 18.1348 29.541 15.5233L28.3829 16.4767ZM28.8336 16.7389C35.2364 17.8515 40.105 23.4368 40.105 30.1576H41.605C41.605 22.695 36.1995 16.4964 29.0903 15.2611L28.8336 16.7389ZM40.105 30.1576C40.105 37.68 34.007 43.778 26.4847 43.778V45.278C34.8354 45.278 41.605 38.5084 41.605 30.1576H40.105ZM26.4847 43.778C22.248 43.778 18.4635 41.8445 15.9642 38.8089L14.8062 39.7624C17.5782 43.1292 21.7808 45.278 26.4847 45.278V43.778ZM17.8625 38.7484C17.0609 38.7484 16.2761 38.6792 15.5136 38.5467L15.2568 40.0246C16.1038 40.1718 16.9745 40.2484 17.8625 40.2484V38.7484Z"
        fill="#9C9C9A"
      />
      <path
        d="M52 92.9535V79.5L49 79.3488V94L52 92.9535Z"
        stroke="#9C9C9A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46 93.5V79.5H49V94L46 93.5Z"
        stroke="#9C9C9A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46 89.0286L28 94.5143L54.5167 100L71 92L52.5 89.0286"
        stroke="#9C9C9A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71 92V95.1143L54.5167 103L28 97.5143V94.5"
        stroke="#9C9C9A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="109"
        cy="48"
        r="1"
        stroke="#1A1A1A"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="84"
        cy="25"
        r="1"
        stroke="#1A1A1A"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="66"
        cy="35"
        r="1"
        stroke="#1A1A1A"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="61"
        cy="8"
        r="1"
        stroke="#1A1A1A"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="4"
        cy="19"
        r="1"
        stroke="#1A1A1A"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="2"
        cy="49"
        r="1"
        stroke="#1A1A1A"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="43"
        cy="2"
        r="1"
        stroke="#1A1A1A"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="4"
        cy="71"
        r="1"
        stroke="#1A1A1A"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="91"
        cy="80"
        r="1"
        stroke="#1A1A1A"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default EmptyCart;
